import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {
  constructor(private http: HttpClient) { }

  async search(criteria?: any, from = 0, limit = 20) {
    return this.http.post<{ assessments: any[], total: number }>(environment.app.apiUrl + 'assessment/search', criteria, {
      params: { from, limit }
    }).toPromise();
  }

  async save(assessment: any) {
    return this.http.post<any>(environment.app.apiUrl + 'assessment/save', assessment).toPromise();
  }

  get(id: string) { return this.http.get(environment.app.apiUrl + 'assessment/' + id).toPromise(); }

  async pay(id: string) {
    const redirect: any = await this.http.get(environment.app.apiUrl + 'assessment/pay/' + id).toPromise();
    location.href = redirect.link;
  }

  async saveResult(assessment: any) {
    return this.http.post<any>(environment.app.apiUrl + 'assessment/result', assessment).toPromise();
  }
}
